/* Homepage-only interaction refinements. Commerce handlers remain in the theme. */
(() => {
  const init = () => {
    const quiz = document.querySelector('#ch-quiz');
    if (quiz && !quiz.dataset.editorialEnhanced) {
      quiz.dataset.editorialEnhanced = 'true';
      let active = quiz.querySelector('.ch-quiz__step.is-active');
      const focusStep = () => {
        const next = quiz.querySelector('.ch-quiz__step.is-active, .ch-quiz__result.is-active');
        if (!next || next === active) return;
        active = next;
        const title = next.querySelector('.ch-quiz__q, .ch-quiz__res-name');
        if (title) {
          title.setAttribute('tabindex', '-1');
          title.focus({ preventScroll: true });
          title.scrollIntoView({ block: 'nearest', behavior: 'instant' });
        }
      };
      const observer = new MutationObserver(focusStep);
      quiz.querySelectorAll('.ch-quiz__step, .ch-quiz__result').forEach(step => {
        observer.observe(step, { attributes: true, attributeFilter: ['class'] });
      });
    }
    if ('IntersectionObserver' in window && !document.body.dataset.editorialSticky) {
      document.body.dataset.editorialSticky = 'true';
      const visible = new Set();
      const mobileVisible = new Set();
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const targets = entry.target.matches('.ch-prod-card__atc, .ch-cream__actions') ? mobileVisible : visible;
          entry.isIntersecting ? targets.add(entry.target) : targets.delete(entry.target);
        });
        document.body.classList.toggle('ed-inline-action', visible.size > 0);
        document.body.classList.toggle('ed-mobile-inline-action', mobileVisible.size > 0);
      });
      document.querySelectorAll('.ch-quiz-split, .ch-trio__actions, .ch-faq, .cupra-footer, .ch-prod-card__atc, .ch-cream__actions').forEach(el => observer.observe(el));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
